import { FC, useContext, useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { SocketContext, TeamContext, UserContext } from "../context";
import { SlotMachinePage } from "../pages";
import { VoteToThrowAUserOutModal, ReJoinTheGame } from "../components/molecules";

import { useSound } from "../hooks";
import { Phase } from "../util/enums";
import { IPlayer} from "../interfaces";
import { MuteButton } from "../components/atoms";
import { getUrlTokenExtracted } from "../context/helpers";

const SlotmachineRoute: FC<{}> = () => {
	const { teamNumber, gameId, game, urlToken } = useContext(TeamContext);
	const { socket } = useContext(SocketContext);
	const { userData } = useContext(UserContext);
	const [ isSoundPlaying, setIsSoundPlaying ] = useState(false);
	const [isAnyUserCurrentlyLoggedOut, setIsAnyUserCurrentlyLoggedOut] = useState<boolean>(false);
	const [listOfTheUsersWhoLoggedout, setListOfTheUsersWhoLoggedout] = useState<IPlayer[]>([]);
	let history = useHistory();
	const {playSound, stopSound} = useSound();

	const kickAUserThatClosesTab = (selectedUserEmail: string) => {
		if (game?.phase == Phase.CHOOSING_SOLUTION_CARDS) {
			let payload = {
				matchId: getUrlTokenExtracted(),
				gameId: 1,
				playerEmail: selectedUserEmail
			  };
			socket?.emit("kickPlayer",payload);
		}
    }
	
	const checkIfAnyOfTheUsersLoggedOutDuringTheGame = useCallback (() => {
		let listOfThePlayers = game?.gameInfo?.players;
		let isAnyUserOut = false;
		let helperArray = [];
		setListOfTheUsersWhoLoggedout([]);
		
		for (const playerEmail in listOfThePlayers) {
			if (listOfThePlayers[playerEmail].status === 3) {
		
				isAnyUserOut = true;
				let expectedPlayer = game?.players.find((player: IPlayer) => { return player.email === playerEmail });
			
				if (expectedPlayer)
				helperArray.push(expectedPlayer);

				kickAUserThatClosesTab(playerEmail);
			}
		}
		
		setListOfTheUsersWhoLoggedout(helperArray);
	
		if (isAnyUserOut)
		setIsAnyUserCurrentlyLoggedOut(true);

		if (!isAnyUserOut) 
			setIsAnyUserCurrentlyLoggedOut(false);
	},[game?.gameInfo?.players, game?.players]);

	const playTheSound = useCallback(() => {
		if(game?.phase === Phase.SLOT_MACHINE && !isSoundPlaying){
			setIsSoundPlaying(true);
			playSound("/sounds/slotmachineintro.mp3");
		}
	}, [game?.phase, isSoundPlaying, playSound] );

	useEffect(() => {
		playTheSound();
	}, [playTheSound])

	useEffect(() => {
		checkIfAnyOfTheUsersLoggedOutDuringTheGame();
	}, [game?.gameInfo?.players, checkIfAnyOfTheUsersLoggedOutDuringTheGame]);

	let condition = teamNumber && userData && (game?.phase === Phase.CHOOSING_SOLUTION_CARDS || game?.phase === Phase.PICK_DILEMMA || game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.ACTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.RENDER_SPIN_WHEEL);


	useEffect(() => {
		if (condition && isSoundPlaying){
			setIsSoundPlaying(false);
			stopSound();
		}
	}, [condition, isSoundPlaying, stopSound])
	
	
	useEffect(() => {
		if (condition)
			history.push( "/board/" + urlToken );
	}, [condition, gameId, history, urlToken]);

	// const muteTheSound = () => {
	// 	stopSound();
	// }

	// const unmuteTheSound = () => {
	// 	playSound("/sounds/slotmachineintro.mp3");
	// }

	return(
		<div>
			{(!teamNumber || !userData) && !game && <ReJoinTheGame />}
			{teamNumber && userData && game?.phase === Phase.SLOT_MACHINE && <SlotMachinePage />}
			{/* {isAnyUserCurrentlyLoggedOut && <VoteToThrowAUserOutModal dataOfTheUserWhoLoggedOut={listOfTheUsersWhoLoggedout} />} */}
			<MuteButton />
		</div>
	)
}

export default SlotmachineRoute;